import { render, staticRenderFns } from "./fjordkraft.vue?vue&type=template&id=0d0129e0&scoped=true&"
var script = {}
import style0 from "./fjordkraft.vue?vue&type=style&index=0&id=0d0129e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0129e0",
  null
  
)

export default component.exports